import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgModule } from '@angular/core';
//import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ContentResultRoutingModule } from './content-result-routing.module';
import { ContentResultComponent } from './content-result.component';
import { CategoryResultComponent } from './category-result/category-result.component';
////import { SharedModule } from '../shared/shared.module';
import { ResultsSearchService } from '../home/results-search.service';
import { HotelResultComponent } from './category-result/result/base-result/information/categories/hotel-result/hotel-result.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule, TabsModule, BsDropdownModule, AccordionModule } from 'ngx-bootstrap';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule } from '@angular/forms';
import { ActivitiesResultComponent } from './category-result/result/base-result/information/categories/activities-result/activities-result.component';

import { DisneyResultComponent } from './category-result/result/base-result/information/categories/disney-result/disney-result.component';
import { PThemesResultComponent } from './category-result/result/base-result/information/categories/p-themes-result/p-themes-result.component';

import { TruncateModule } from 'ng2-truncate';
import { CruisesResultComponent } from './category-result/result/base-result/information/categories/cruises-result/cruises-result.component';
import { PackagesResultComponent } from './category-result/result/base-result/information/categories/packages-result/packages-result.component';
import { InsuranceResultComponent } from './category-result/result/base-result/information/categories/insurance-result/insurance-result.component';
import { ItinerarySummaryModule } from '../itinerary-summary/itinerary-summary.module';
//import { LoadingModule } from 'ngx-loading';
import { configLoading } from '../shared/config.loading';
import { CompareModalComponent } from '../shared/compare-modal/compare-modal.component';
//import { NgxLoadingModule } from 'ngx-loading';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {MatSliderModule} from '@angular/material/slider';
import {NgxSliderModule } from '@angular-slider/ngx-slider';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { HotelsComponent } from 'app/home/search-box/categories/hotels/hotels.component';
import { TransportsComponent } from 'app/home/search-box/categories/transports/transports.component';
import { RentcarsComponent } from 'app/home/search-box/categories/rentcars/rentcars.component';
import { InsuranceComponent } from 'app/home/search-box/categories/insurance/insurance.component';
import { PackagesComponent } from 'app/home/search-box/categories/packages/packages.component';
import { MultiDestinationComponent } from 'app/multi-destination/multi-destination.component';
import { ActivitiesComponent } from 'app/home/search-box/categories/activities/activities.component';
import { PthemesComponent } from 'app/home/search-box/categories/pthemes/pthemes.component';
import { BarRatingModule } from 'ngx-bar-rating';
import { MatSelectModule } from '@angular/material';
import { FlightResultComponent } from './category-result/result/base-result/information/categories/flight-result/flight-result.component';
import { FlightsComponent } from 'app/home/search-box/categories/flights/flights.component';
import { DetailModalFlightResultComponent } from './category-result/result/base-result/information/categories/flight-result/detail-modal-flight-result/detail-modal-flight-result.component';
import { RentACarFilterComponent } from './content-result-categories-filter/rent-a-car-filter/rent-a-car-filter.component';
import { FlightsFilterComponent } from './content-result-categories-filter/flights-filter/flights-filter.component';
import { CardPriceComponent } from './category-result/result/base-result/container-price/card-price.component';
import { BookingActionsComponent } from './category-result/result/base-result/container-price/booking-actions.component';
import { ActionButtonsComponent } from './category-result/result/base-result/information/action-buttons/action-buttons.component';
import { TransportResultComponent } from './category-result/result/base-result/information/categories/transport-result/transport-result.component';
import { SummaryResultComponent } from './category-result/result/base-result/information/categories/summary-result/summary-result.component';
import { RentACarResultComponent } from './category-result/result/base-result/information/categories/rent-a-car-result/rent-a-car-result.component';
import { ProductMediaComponent } from './category-result/result/base-result/product-media/product-media.component';
import { BaseResultComponent } from './category-result/result/base-result/base-result.component';
import { BlickoinsComponent } from './category-result/result/base-result/container-price/blickoins.component';
import { PromotionsComponent } from './category-result/result/base-result/container-price/promotions.component';
import { BaseResultsCategoriesComponent } from 'app/shared/modals-results-categories/base-results-categories/base-results-categories.component';

@NgModule({
    imports: [
        MatSliderModule,
        NgxSliderModule,
        CommonModule,
        TranslateModule,
        ContentResultRoutingModule,
        NgxPaginationModule,
        ModalModule.forRoot(),
        CarouselModule,
        TabsModule.forRoot(),
        //BsDropdownModule.forRoot(),
        ItinerarySummaryModule,

        BrowserAnimationsModule,
        //NgxChartsModule,
        FormsModule,
        TruncateModule,
        //NgxLoadingModule.forRoot(configLoading),
        AccordionModule.forRoot(),
        //NgbModule.forRoot(),
        NgxSpinnerModule,
        SharedModule,
        MatCheckboxModule,
        MatIconModule,
        ScrollingModule,
        TooltipModule,
        AngularSvgIconModule.forRoot(),
        BarRatingModule,
        MatSelectModule
     //   InfiniteScrollModule
    ],
    declarations: [
        ContentResultComponent,
        CategoryResultComponent,
        HotelResultComponent,
        ActivitiesResultComponent,
        TransportResultComponent,
        SummaryResultComponent,
        DisneyResultComponent,
        PThemesResultComponent,
        RentACarResultComponent,
        CruisesResultComponent,
        PackagesResultComponent,
        InsuranceResultComponent,
        CompareModalComponent,
        FlightResultComponent,
        DetailModalFlightResultComponent,
        RentACarFilterComponent,
        FlightsFilterComponent,
        BaseResultComponent,
        CardPriceComponent,
        BookingActionsComponent,
        ActionButtonsComponent,
        ProductMediaComponent,
        BlickoinsComponent,
        PromotionsComponent

    ],
    entryComponents: [
      HotelsComponent,
      TransportsComponent,
      RentcarsComponent,
      InsuranceComponent,
      PackagesComponent,
      MultiDestinationComponent,
      ActivitiesComponent,
      PthemesComponent,
      CompareModalComponent,
      FlightsComponent,
      DetailModalFlightResultComponent,
      BaseResultsCategoriesComponent
    ],
    providers: [
        ResultsSearchService,
    ]
})
export class ContentResultModule { }
